export default {
    PAGE_HOME: '首頁',
    PAGE_DASHBOARD: '後臺首頁',
    PAGE_INTEGREATED_SERACH: '整合查詢',
    PAGE_DIGITAL_RESOURCE_MANAGEMENT: '數位資源管理',
    PAGE_GROUP_FILE_TYPE_MANAGEMENT: '檔案類別管理',
    PAGE_RECORDGROUP_MANAGEMENT: '全宗管理',
    PAGE_SUB_RECORDGROUP_MANAGEMENT: '次全宗管理',
    PAGE_FOLDER_MANAGEMENT: '案卷管理',
    PAGE_GROUP_SYSTEM_MANAGEMENT: '系統管理',
    PAGE_ACCOUNT_MANAGEMENT: '帳號管理',
    PAGE_PASSWORD_MANAGEMENT: '密碼管理',
    PAGE_SYSTEM_LOG: '系統日誌',
    PAGE_ISSUE_REPORT_MANAGEMENT: '問題回報管理',
    PAGE_SYNONYM_MANAGEMENT: '同義詞彙設定',
    PAGE_MY_ISSUE_REPORT: '我的問題回報',
    PAGE_GROUP_REVIEW_MANAGEMENT: '審核專區',
    PAGE_REVIEW: '審核資料',
    PAGE_FRONT_STAGE_DATA: '前臺開放資料',
    PAGE_GROUP_FRONT_STAGE_MANAGEMENT: '網站管理',
    PAGE_THEME_MANAGEMENT: '主題專區管理',
    PAGE_LATEST_NEWS_MANAGEMENT: '最新消息管理',
    PAGE_RECOMMENDED_ARTICLE_MANAGEMENT: '本日精選管理',
    PAGE_FREQUENTLY_ASKED_QUESTION_MANAGEMENT: '常見問題管理',
}